import { Pipe, PipeTransform } from '@angular/core';
import { TaskStatus } from '@workspaces/models/task';

@Pipe({
  name: 'kanbanId',
  standalone: true,
  pure: true
})
export class KanbanIdPipe implements PipeTransform {
  transform(value: TaskStatus | string): string {
    if (!value) {
      return '';
    }
    if (value === 'todo') {
      return 'To do';
    }

    let result = value.toString().replace(/[_ -]/g, ' ');

    result = result.charAt(0).toUpperCase() + result.slice(1);

    return result;
  }
}
